export const MODAL_TYPE_UNFOLLOW_CATEGORY = 'unfollow-category';
